import loggingService from '@/services/util/loggingService'
import divisionService from '@/services/divisionService'
import store from '@/store/index'

var serviceName = 'userService'
var path = '/User/'
var isDebug = false

const adminRoles = [
    'Administrator'
]

const staffRoles = [
    'HCB Manager Staff'
]

const viewOnlyRoles = [
    'Spills Manager Viewer',
    'Ground Water Viewer',
    'Uranium Viewer',
    'Air Viewer',
    'Water Wastewater Viewer',
    'Solid Waste Viewer',
    'HCB Manager Viewer'
]

// check if user's roleList matches any of the checkRoleList
function hasRoleCheck (checkRoleList) {
    let spillsUserDto = store.state.auth.spillsUserDto || {}
    let userRoleList = spillsUserDto.roleList
    if (userRoleList) {
        var checkRoleListUpper = checkRoleList.map(role => role.toUpperCase())
        return userRoleList.some(role => {
            return checkRoleListUpper.includes(role.toUpperCase())
        })
    } else {
        return false
    }
}

function isAdministrator () {
    return hasRoleCheck(adminRoles)
}

function isStaff () {
    return hasRoleCheck(staffRoles)
}

function isViewOnlyUser () {
    return !hasRoleList() || hasRoleCheck(viewOnlyRoles)
}

function hasRoleList () {
    let spillsUserDto = store.state.auth.spillsUserDto || {}
    return !!spillsUserDto.roleList && spillsUserDto.roleList.length > 0
}

function getUserDivision () {
    let spillsUserDto = store.state.auth.spillsUserDto || {}
    let userRoleList = spillsUserDto.roleList
    if (userRoleList) {
        if (userRoleList.some(role => role.includes('Administrator'))) {
            return divisionService.DivisionEnum.Admin
        } else if (userRoleList.some(role => role.includes('Spills Manager'))) {
            return divisionService.DivisionEnum.SpillsManager
        } else if (userRoleList.some(role => role.includes('Ground Water'))) {
            return divisionService.DivisionEnum.GroundWater
        } else if (userRoleList.some(role => role.includes('Uranium'))) {
            return divisionService.DivisionEnum.Uranium
        } else if (userRoleList.some(role => role.includes('Air'))) {
            return divisionService.DivisionEnum.Air
        } else if (userRoleList.some(role => role.includes('Water Wastewater'))) {
            return divisionService.DivisionEnum.WaterWastewater
        } else if (userRoleList.some(role => role.includes('Solid Waste'))) {
            return divisionService.DivisionEnum.SolidWaste
        } else if (userRoleList.some(role => role.includes('HCB Manager'))) {
            return divisionService.DivisionEnum.HCBManager
        }
    }
    return divisionService.DivisionEnum.SpillsManager
}

function getCurrentSpillsUserDto (http) {
    loggingService.log(isDebug, serviceName, 'getCurrentSpillsUserDto')
    return http.get(path + 'getCurrentSpillsUserDto')
}

function listUserResultDtos (http) {
    loggingService.log(isDebug, serviceName, 'listUserResultDtos')
    return http.get(path + 'ListUserResultDtos')
}

function listActiveUserResultDtos (http) {
    loggingService.log(isDebug, serviceName, 'listActiveUserResultDtos')
    return http.get(path + 'ListActiveUserResultDtos')
}

function searchNewUsers (http, showInactive) {
    loggingService.log(isDebug, serviceName, 'searchNewUsers')
    return http.get(path + 'SearchNewUsers?showInactive=' + showInactive)
}

function saveUser (http, userDto) {
    loggingService.log(isDebug, serviceName, 'put')
    return http.put(path + 'SaveUser', userDto)
}

function setUserInactive (http, userDto) {
    loggingService.log(isDebug, serviceName, 'put')
    return http.put(path + 'SetUserInactive', userDto)
}

export default {
    getCurrentSpillsUserDto: getCurrentSpillsUserDto,
    isAdministrator: isAdministrator,
    isStaff: isStaff,
    isViewOnlyUser: isViewOnlyUser,
    listUserResultDtos: listUserResultDtos,
    searchNewUsers: searchNewUsers,
    saveUser: saveUser,
    setUserInactive: setUserInactive,
    hasRoleList: hasRoleList,
    listActiveUserResultDtos: listActiveUserResultDtos,
    getUserDivision: getUserDivision
}
